import React, { FC } from 'react';

import { Button } from 'src/presentation/components/agent_desktop_components';
import Form, { useForm, FormEditorProps } from 'src/presentation/components/forms/Form';
import Footer from 'src/presentation/components/forms/Footer';
import { H1 } from '@ad-scripts/presentation/components/common/headers';
import Input from 'src/presentation/components/forms/Input';
import { Body, Row, Section } from 'src/presentation/components/forms/Layout';
import relationshipLabelsResource from 'src/actions/relationshipLabels/relationshipLabelResource';

const dataAidPrefix = 'admin-relationship-labels-';

const RelationshipLabelEditor: FC<FormEditorProps> = ({ errors, item, root }) => {
  const formContext = useForm({
    add: relationshipLabelsResource.effects.add,
    defaultItem: { displayName: '' },
    errors,
    item,
    resetErrors: relationshipLabelsResource.actions.resetErrors,
    root,
    update: relationshipLabelsResource.effects.update,
    validate: relationshipLabelsResource.effects.validate,
  });
  const { onClose, onSave, isNew } = formContext;

  return (
    <Form context={formContext}>
      <H1>{isNew ? 'Add' : 'Edit'} Relationship</H1>

      <Body data-aid={`${dataAidPrefix}editor`}>
        <Section>
          <Row>
            <Input
              data-aid={`${dataAidPrefix}editor-name-input`}
              attr="displayName"
              autoFocus
              label="Name"
              placeholder="e.g. Spouse or Executive Assistant"
            />
          </Row>
        </Section>
      </Body>

      <Footer>
        <Button data-aid={`${dataAidPrefix}editor-cancel`} type={Button.Types.TEXT} onClick={onClose}>
          Cancel
        </Button>
        <Button data-aid={`${dataAidPrefix}editor-save`} onClick={onSave}>
          {isNew ? 'Add Relationship' : 'Save'}
        </Button>
      </Footer>
    </Form>
  );
};

export default RelationshipLabelEditor;
